import { useTimer } from "../hooks/useTimer";
import { PlaylistItemDTO } from "../lib/types";

interface Props {
  currentIndex: number;
  playingItem: PlaylistItemDTO;
}

export const DSPlayerDebugView: React.FC<Props> = ({ currentIndex, playingItem }) => {
  const { count } = useTimer(0);
  return (
    <div className="fixed top-0 right-0 w-[150px] bg-white text-black text-xs p-1" style={{ zIndex: 999 }}>
      <div>Item index: {currentIndex}</div>
      <div>Item duration: {playingItem?.duration}</div>
      <div>Item Type: {playingItem?.type}</div>
      <div>Timer: {count}</div>
    </div>
  );
};
